"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=require("./index71.js");var t=r.requireObjectCoercible,c=Object,b=function(e){return c(t(e))};exports.toObject=b;
